import { render, staticRenderFns } from "./myDci-order-Up.vue?vue&type=template&id=3c0b6ae2&scoped=true&"
import script from "./myDci-order-Up.vue?vue&type=script&lang=js&"
export * from "./myDci-order-Up.vue?vue&type=script&lang=js&"
import style0 from "./myDci-order-Up.vue?vue&type=style&index=0&id=3c0b6ae2&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0b6ae2",
  null
  
)

export default component.exports